import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isBrowserSupportVisibilityApi, hasTabFocus } from 'utils/window';

import { utils } from '@amplement/backend-connector';

const getEventName = () => {
    if (typeof document.hidden !== 'undefined') {
        return 'visibilitychange';
    }
    if (typeof document.mozHidden !== 'undefined') {
        return 'mozvisibilitychange';
    }
    if (typeof document.msHidden !== 'undefined') {
        return 'msvisibilitychange';
    }
    if (typeof document.webkitHidden !== 'undefined') {
        return 'webkitvisibilitychange';
    }
    return {};
}

class Visibility extends PureComponent {

    constructor(props) {
        super(props);

        this.visibilityEventName = getEventName();
        this.updateVisibilityState();
    }

    componentDidMount() {
        window.addEventListener('focus', this.updateFocusState(true));
        window.addEventListener('blur', this.updateFocusState(false));
        if (isBrowserSupportVisibilityApi) {
            document.addEventListener(this.visibilityEventName, this.updateVisibilityState);
        } else {
            utils.errorHandler.captureException(new Error('Custom: browser not support the page visibility API'), 'component:Visibility');
        }
    }

    componentWillUnmount() {
        window.removeEventListener('focus', this.updateFocusState(true));
        window.removeEventListener('blur', this.updateFocusState(false));
        if (isBrowserSupportVisibilityApi) {
            document.removeEventListener(this.visibilityEventName, this.updateVisibilityState);
        }
    }

    updateFocusState = isFocused => () => {
        if (this.props.hasTabFocus !== isFocused) {
            this.props.setTabFocus(isFocused);
            // logger.log('Changing tab focus to ', isFocused);
        }
    }

    updateVisibilityState = () => {
        const isFocused = hasTabFocus();

        if (this.props.hasTabFocus !== isFocused) {
            this.props.setTabFocus(isFocused);
            // logger.log('Changing tab visibility to ', isFocused);
        }
    }

    render() {
        return null;
    }
}

Visibility.propTypes = {
    hasTabFocus: PropTypes.bool,
    setTabFocus: PropTypes.func.isRequired
};

Visibility.defaultProps = {
    hasTabFocus: true
};

export default Visibility;
